import { render, staticRenderFns } from "./new-data-dialog.vue?vue&type=template&id=92cd8e6a"
import script from "./new-data-dialog.vue?vue&type=script&lang=js"
export * from "./new-data-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports